<template>
  <Drawer width="1200" v-model="drawerOpened">
    <div class="handle-wrapper">
      <div class="line topTitle">新客户开发</div>
      <h1 class="customer-name">{{ customerName }}</h1>
      <div class="table-wrap">
        <Table :columns="columns" :data="currentCustomerDevelop">
          <template slot-scope="{ row, index }" slot="verify">
            <div
              v-if="
                row.status === 'applying' &&
                (user.superAdmin ||
                  arrayIntersection(
                    ['salesAssist', 'salesDirector'],
                    user.simpleRole
                  ).length > 0)
              "
            >
              <Button
                type="primary"
                size="small"
                style="margin-right: 5px"
                @click="operate('agree')"
                >同意</Button
              >
              <Button type="error" size="small" @click="clickRefuse"
                >拒绝</Button
              >
              <Modal
                v-model="isShowModel"
                title="选择拒绝原因"
                @on-ok="okRefuse"
                @on-cancel="cancelRefuse"
                width="20px"
              >
                <RadioGroup vertical v-model="refuseReason">
                  <Radio label="集团客户"></Radio>
                  <Radio label="已有指定人跟进"></Radio>
                  <Radio label="客户资质差"></Radio>
                </RadioGroup>
              </Modal>
            </div>
            <div v-else>{{ status }}</div>
          </template>
        </Table>
        <div class="historyCustomerDevelop-wrap">
          <div class="historyCustomerDevelop-title">历史开发数据</div>
          <Table
            :loading="tableLoading"
            :columns="columns"
            :data="customerDevelopForCustomer"
          >
            <template slot-scope="{ row, index }" slot="verify">
              <div v-if="row.status === 'applying'">申请中</div>
              <div v-if="row.status !== 'applying' && row.status !== 'refuse'">
                同意
              </div>
              <div v-if="row.status === 'refuse'">拒绝</div>
            </template>
          </Table>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";

const statusToText = {
  applying: "申请中",
  agree: "已同意",
  refuse: "已拒绝",
  expired: "已过期",
  success: "开发完成",
  abandon: "已放弃",
};
export default {
  name: "CustomerDevelopDrawer",
  props: {
    indexFilter: Object,
  },
  data() {
    return {
      drawerOpened: false,
      customerDevelop: [],
      currentCustomerDevelop: [],
      customerDevelopId: "",
      applyingCustomerDevelop: [],
      status: undefined,
      tableLoading: false,
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h("span", { style: { color: "darkgray" } }, params.index + 1),
        },
        {
          title: "开发人员",
          key: "responsiblePerson",
          align: "center",
          render: (h, params) => {
            return h("div", params.row.responsiblePerson.name);
          },
        },
        {
          title: "部门",
          key: "departMent",
          align: "center",
          render: (h, params) => {
            return h("div", params.row.department.name);
          },
        },
        {
          title: "开始时间",
          key: "createdAt",
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.createdAt).format("YYYY-MM-DD HH:mm")
            );
          },
          align: "center",
        },
        {
          title: "截止时间",
          key: "expiredAt",
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.expiredAt).format("YYYY-MM-DD HH:mm")
            );
          },
          align: "center",
        },
        {
          title: "当前阶段",
          key: "status",
          render: (h, params) => {
            return h("div", statusToText[params.row.status]);
          },
          align: "center",
        },
        {
          title: "审核",
          slot: "verify",
          width: 150,
          align: "center",
        },
        {
          title: "操作",
          key: "operate",
          render: (h, params) => {
            return h("div", "操作");
          },
        },
      ],
      filterQuery: {},
      isShowModel: false,
      refuseReason: "已有指定人跟进",
      customerName: "",
    };
  },
  computed: {
    ...mapState({
      customerDevelopForCustomer: (state) =>
        state.customerDevelop.customerDevelopForCustomer,
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getCustomerDevelopForCustomer:
        "customerDevelop/getCustomerDevelopForCustomerAction",
      customerDevelopOperate: "customerDevelop/customerDevelopOperateAction",
      getCustomerDevelop: "customerDevelop/getCustomerDevelopAction",
      getCustomerDevelopById: "customerDevelop/getCustomerDevelopByIdAction",
    }),
    async openDrawer(customerDevelop) {
      this.tableLoading = true;
      this.currentCustomerDevelop = [];
      const currentCustomerDevelop = await this.getCustomerDevelopById(
        customerDevelop._id
      );
      this.currentCustomerDevelop.push(currentCustomerDevelop);
      this.customerName = customerDevelop.customer.name;
      this.status = statusToText[currentCustomerDevelop.status];
      this.getCustomerDevelopOneMethod(customerDevelop);
      this.tableLoading = false;
      this.drawerOpened = true;
    },

    async getCustomerDevelopOneMethod(customerDevelop) {
      await this.getCustomerDevelopForCustomer({
        customer: customerDevelop.customer._id,
      });
    },

    clickRefuse() {
      this.isShowModel = true;
    },
    okRefuse() {
      this.operate("refuse");
    },
    cancelRefuse() {},

    // 审批
    operate(e) {
      let data = {};
      data.status = e;
      data.customer = this.currentCustomerDevelop[0].customer._id;
      const userId = this.user._id;
      if (e === "agree") {
        data.agreedBy = userId;
        this.operateMethod(data);
      } else if (e === "refuse") {
        data.refusedBy = userId;
        data.refuseReason = this.refuseReason;
        this.operateMethod(data);
      }
    },
    async operateMethod(data) {
      const id = this.currentCustomerDevelop[0]._id;
      try {
        const newCustomerDevelop = await this.customerDevelopOperate({
          id,
          data,
        });
        this.currentCustomerDevelop = [];
        const currentCustomerDevelop = await this.getCustomerDevelopById(
          newCustomerDevelop._id
        );
        this.currentCustomerDevelop.push(currentCustomerDevelop);
        this.status = statusToText[currentCustomerDevelop.status];
        await this.getCustomerDevelop(this.indexFilter);
      } catch (error) {
        this.$Message.error(`审核失败: ${error}`);
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  padding 20px

.topTitle
  font-size 21px
  margin-bottom 30px

.wrap
  padding 20px

  .item
    width 260px
    display inline-block
    margin-bottom 20px

    div
      font-size 16px

.line
  border-bottom 1px solid #E2E5ED

.customer-name
  margin-bottom 20px

.historyCustomerDevelop-wrap
  margin-top 30px

  .historyCustomerDevelop-title
    font-size 19px
    margin-bottom 30px
</style>